module.exports = __webpack_public_path__ + "img/cs.dab7993c.png";